module.exports = __webpack_public_path__ + "media/images/flags/32/Faroes-70ec78b6114dec6feac4a933c99f3ea6.png";